const ShaderPresets = {
  default: {
    material: {
      color: 0xc8c8c8,
      shininess: 30,
      specular: 0x080808,
      emissive: 0x111111,
      opacity: 0.95,
    },
    lights: {
      ambient: [0x909090],
      light: [0xffffff, 0.48],
      light2: [0xffffff, 0.43],
    },
  },
  black: {
    material: {
      color: 0x333333,
      shininess: 32,
      specular: 0x080808,
      emissive: 0x000000,
      opacity: 0.95,
    },
    lights: {
      ambient: [0x909090],
      light: [0xffffff, 1.0],
      light2: [0xffffff, 1.0],
    },
  },
  white: {
    material: {
      color: 0xfdfbfe,
      shininess: 32,
      specular: 0x080808,
      emissive: 0x000000,
      opacity: 0.95,
    },
    lights: {
      ambient: [0xa0a0a0],
      light: [0xffffff, 0.28],
      light2: [0xffffff, 0.23],
    },
  },
  point: {
    material: {
      color: 0x000000,
    },
  },
};

export default ShaderPresets;
